<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import Fake from '../Fake/Fake.vue';

export default {
    components: {
        DropdownMenu,
        Fake
    },
    computed: {
        ...mapState({
            sites: state => state.allocation.filters.sites,
            suppliers: state => state.allocation.filters.suppliers,
            selected: state => state.allocation.filters.selected,
            loading: state => state.allocation.list.loading,
            user: state => state.auth.user,
            supplier: state => state.auth.supplier
        }),
        ...mapGetters({
            accommodations: 'allocation/accommodations',
            filteredSites: 'allocation/filteredSites'
        })
    },
    methods: {
        ...mapActions({
            setSelectedFilters: 'allocation/setSelectedFilters'
        })
    }
}
</script>
<template>
    <div class="allocation-filters">
        <transition name="fade" mode="out-in">
            <div v-if="!loading" :key="'body'" class="allocation-filters__body">
                <div class="allocation-filters__option">
                    <dropdown-menu :label="$t('bookingFilters.site.label')"
                                   :value="selected.site"
                                   :items="filteredSites"
                                   :enable-deselect="true"
                                   :undefined-value="$t('bookingFilters.site.all')"
                                   @input="setSelectedFilters({site: $event})"/>
                </div>
            </div>
            <fake v-if="loading"
                  :body-rows="1"
                  :body-cells="1"
                  :key="'fake'"/>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AllocationFilters/AllocationFilters.vue